import React, { useState } from 'react';
import { FieldTextInput } from '../FieldTextInput';
import AddImage from '../AddImage/AddImage';
import { StageFirstScreenProps } from './types';
import './StageFirstScreen.scss';
import strings from '../../resources/strings';
import { autoId } from '../../utils/UidGenerator';
import { Stage } from '../../store/missions/types';
import { storage } from '../../resources/storage';
import { TextareaAutosize } from '@mui/material';

const StageFirstScreen: React.FC<StageFirstScreenProps> = (props) => {
    const [image, setImage] = useState(props.data?.image ?? '');
    const [stage] = useState<Stage>(
        props.data ?? {
            id: autoId(),
            name: {},
            description: {},
            order: 0,
        },
    );
    const [description, setDescription] = useState(stage.description);

    return (
        <div className="stage-first-screen">
            <h2>{strings.missions.addStageDialog.firstScreenLabel}</h2>
            {props.languages.map((lang) => (
                <div key={`description_${lang.code}`}>
                    <TextareaAutosize
                        defaultValue={description?.[lang.code]}
                        id={`description_${lang.code}`}
                        placeholder="First screen description"
                        name={`description_${lang.code}`}
                        maxRows={6}
                        style={{ display: lang.code !== props.selectedLanguage ? 'none' : 'block' }}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                            setDescription({ ...description, [lang.code]: e.target.value });
                        }}
                    ></TextareaAutosize>
                    <FieldTextInput
                        value={description?.[lang.code]}
                        variant="outlined"
                        required={false}
                        type="text"
                        id={`description_${lang.code}`}
                        label="First screen description"
                        name={`description_${lang.code}`}
                        hidden={true}
                    ></FieldTextInput>
                </div>
            ))}
            <FieldTextInput
                value={image}
                hidden={true}
                variant="outlined"
                required={false}
                type="text"
                id="image"
                label=""
                name="image"
            ></FieldTextInput>
            <AddImage
                path={storage.stages}
                showMessage={false}
                customName={stage.id}
                sendOnDrop={true}
                setGetImgAddress={(url: string) => setImage(url)}
                actualEventFile={image}
            ></AddImage>
        </div>
    );
};

export default StageFirstScreen;
